import io from "socket.io-client";

export const socket = io('https://baucua.xanhchin.io');